import { render, staticRenderFns } from "./columnNotes.vue?vue&type=template&id=ef2e1e30&scoped=true"
import script from "./columnNotes.vue?vue&type=script&lang=js"
export * from "./columnNotes.vue?vue&type=script&lang=js"
import style0 from "./columnNotes.vue?vue&type=style&index=0&id=ef2e1e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2e1e30",
  null
  
)

export default component.exports